import Transformer from "../../transformer";
import assetURL from "../../../utils/assetURL";
import ObjectToForm from "../../../utils/objectToForm";

export default class SupplyTransformer extends Transformer {
  static fetch(supply) {
    const supplyType = supply.supply_type;
    const supplyTypeId = supplyType.id || supplyType;
    const supplyTypeName = supplyType.name || supplyType;

    const unitMeasurement = supply.unit_measurement;
    const unitMeasurementId = unitMeasurement.id || unitMeasurement;
    const unitMeasurementName = unitMeasurement.name || unitMeasurement;
    const unitMeasurementAbbr = unitMeasurement.abbr || unitMeasurement;

    const { copies } = supply;

    return {
      code: supply.code || "",
      comment: supply.comment,
      id: supply.id,
      image: assetURL(supply.image),
      isActive: supply.is_active,
      isDivisible: supply.is_divisible,
      name: supply.name,
      sctCode: supply.sct_code,
      subFamilyId: supply.subfamily,
      pictograms: supply.pictograms
        ? supply.pictograms.map((p) => {
            return { src: assetURL(p.file), ...p };
          })
        : null,
      supplyTypeId,
      supplyTypeName,
      supplyTypeShort: supply.supply_type.short_name,

      copies: copies || [],

      unitMeasurementId,
      unitMeasurementName,
      unitMeasurementAbbr,

      unitWeight: supply.unit_weight,
    };
  }

  static send({
    id,
    subFamilyId,
    familyId,
    code,
    sctCode,
    name,
    unitWeight,
    unitMeasurementId,
    supplyTypeId,
    comment,
    isDivisible,
    rejectedPictograms,
    image,
  }) {
    if (!image || typeof image != "object") {
      return {
        id,
        subfamily: subFamilyId,
        family: familyId,
        code: code || null,
        sct_code: sctCode,
        name,
        unit_weight: unitWeight,
        unit_measurement: unitMeasurementId,
        supply_type: supplyTypeId,
        comment,
        is_active: true,
        is_divisible: isDivisible,
        rejected_pictograms: rejectedPictograms,
      };
    } else {
      const fd = ObjectToForm();
      fd.append("id", id);
      fd.append("subfamily", subFamilyId);
      fd.append("family", familyId);
      fd.append("sct_code", sctCode);
      fd.append("name", name);
      fd.append("unit_weight", unitWeight);
      fd.append("unit_measurement", unitMeasurementId);
      fd.append("supply_type", supplyTypeId);
      fd.append("comment", comment);
      fd.append("is_active", true);
      fd.append("is_divisible", true);
      if (code) {
        fd.append("code", code);
      }
      if (rejectedPictograms.length) {
        fd.append("rejected_pictograms", rejectedPictograms);
      }
      fd.append("image", image);
      return fd;
    }
  }
}



// WEBPACK FOOTER //
// ./src/transformers/catalog/supplys/supply.js